import { IdNamePair } from '@cs-cms/types';
import { ExecuteEndpoint } from '../base/BaseApiService';

export class LocalesService {
  public async getLocales(): Promise<IdNamePair[]> {
    return ExecuteEndpoint('locales', 'GET');
  }
}
